import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/completion.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm completion
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/completion.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`Enables tab-completion in all npm commands.`}</p>
    <p>{`The synopsis above
loads the completions into your current shell.  Adding it to
your ~/.bashrc or ~/.zshrc will make the completions available
everywhere:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm completion >> ~/.bashrc
npm completion >> ~/.zshrc
`}</code></pre>
    <p>{`You may of course also pipe the output of `}<inlineCode parentName="p">{`npm completion`}</inlineCode>{` to a file
such as `}<inlineCode parentName="p">{`/usr/local/etc/bash_completion.d/npm`}</inlineCode>{` or
`}<inlineCode parentName="p">{`/etc/bash_completion.d/npm`}</inlineCode>{` if you have a system that will read
that file for you.`}</p>
    <p>{`When `}<inlineCode parentName="p">{`COMP_CWORD`}</inlineCode>{`, `}<inlineCode parentName="p">{`COMP_LINE`}</inlineCode>{`, and `}<inlineCode parentName="p">{`COMP_POINT`}</inlineCode>{` are defined in the
environment, `}<inlineCode parentName="p">{`npm completion`}</inlineCode>{` acts in "plumbing mode", and outputs
completions based on the arguments.`}</p>
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/developers"
        }}>{`npm developers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm"
        }}>{`npm`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      